// extracted by mini-css-extract-plugin
export var arrows = "_5x-5";
export var decrementer = "_5x-9";
export var disabled = "_5x-3";
export var error = "_5x-1";
export var hiddenText = "_5x-a";
export var incrementer = "_5x-8";
export var input = "_5x-7";
export var inputWrapper = "_5x-0";
export var leadingIcon = "_5x-b";
export var readonly = "_5x-2";
export var regular = "_5x-6";
export var small = "_5x-4";